var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.otStakingPools.length > 0)?_c('pp-section',{attrs:{"header":"Deprecated OT Staking"}},[_c('staking-pool-table',{attrs:{"pools":_vm.otStakingPools,"with-expiry":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }